import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { environment } from '@env/environment';
import { Options } from '@shared/models/options';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';

@Injectable({
  providedIn: 'root'
})
export class AccessDataApi extends ApiCommon {
  protected backend = environment.api.backend;


  getAccessDataList(pageEvent, opt?: Options): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;

    if (opt?.q) {
      builder.q = opt.q;
    }

    if (opt?.query) {
      builder.query = opt.query;
    }

    if (opt?.startDate) {
      builder.startDate = opt.startDate
    }

    if (opt?.endDate) {
      builder.endDate = opt.endDate
    }


    if (opt?.chart) {
      return this.apiServer.accessData.getChartAccessDataList(builder.build());
    }

    return this.apiServer.accessData.getAccessDataList(builder.build());
  }

  deleteAccessData(entryId): Observable<any> {
    return this.apiServer.accessData.deleteAccessData(entryId);
  }

  deleteAllAccessData(): Observable<any> {
    return this.apiServer.accessData.deleteAllAccessData();
  }
}
